import React, { useState } from "react";
import { 
    IconButton, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    TextField,
    Tooltip
} from "@material-ui/core";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

const SupportButton = () => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setMessage("");
    };

    const handleSend = async () => {
        if (!message.trim()) {
            toast.error("El mensaje no puede estar vacío");
            return;
        }

        setLoading(true);
        try {
            await api.post("/support/message", { message });
            toast.success("Mensaje enviado a soporte correctamente");
            handleClose();
        } catch (err) {
            toastError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tooltip title="Hablar con soporte">
                <IconButton color="inherit" onClick={handleOpen}>
                    <HelpOutlineIcon />
                </IconButton>
            </Tooltip>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Contactar a Soporte</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Escribe tu mensaje para soporte..."
                        type="text"
                        fullWidth
                        multiline
                        minRows={4}
                        variant="outlined"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary" disabled={loading}>
                        {i18n.t("ticketOptionsMenu.buttons.cancel")}
                    </Button>
                    <Button onClick={handleSend} color="primary" variant="contained" disabled={loading}>
                        {loading ? "Enviando..." : "Enviar"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SupportButton;
